import React from 'react';

import BannerStyleButton from '../BannerStyleButton';

import { ReactComponent as ArrowRightWhiteIcon } from '../../assets/svg/arrow-right-white-icon.svg';
import { ReactComponent as ArrowRightBlackIcon } from '../../assets/svg/arrow-right-black.svg';
import { ReactComponent as LockIcon } from '../../assets/svg/locker-icon.svg';
import { ReactComponent as CheckmarkIcon } from '../../assets/svg/checkmark-green.svg';

import styles from './index.module.scss';

export enum ActionState {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  LOCKED = 'locked',
  COMPLETED = 'completed',
}

const IconsByActionState: Record<ActionState, React.ReactNode> = {
  [ActionState.PRIMARY]: <ArrowRightWhiteIcon />,
  [ActionState.SECONDARY]: <ArrowRightBlackIcon />,
  [ActionState.LOCKED]: <LockIcon />,
  [ActionState.COMPLETED]: <CheckmarkIcon />,
};

export interface ActionStateBannerStyleButtonProps {
  title: string;
  subtitle?: string;
  imageUrl?: string;
  imageAlt?: string;
  url: string;
  actionState?: ActionState;
  bannerStyleButtonOnClick?: () => void;
}

const ActionStateBannerStyleButton: React.FC<
  ActionStateBannerStyleButtonProps
> = ({
  title,
  subtitle,
  imageUrl,
  imageAlt,
  url,
  actionState = ActionState.PRIMARY,
  bannerStyleButtonOnClick,
}) => {
  const iconRightItem = IconsByActionState[actionState];

  return (
    <BannerStyleButton
      title={title}
      subtitle={subtitle}
      imageUrl={imageUrl}
      imageAlt={imageAlt}
      iconRight={iconRightItem}
      url={url}
      className={styles[actionState]}
      onClick={bannerStyleButtonOnClick}
    />
  );
};

export default ActionStateBannerStyleButton;
